import { useRouter } from 'next/router'
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

interface IState {
  videoPlaying: boolean
  setVideoPlaying: Dispatch<SetStateAction<boolean>>
  isEmbed: boolean
}

const defaultState: IState = {
  videoPlaying: false,
  setVideoPlaying: function (value: React.SetStateAction<boolean>): void {
    throw new Error('Function not implemented.' + value)
  },
  isEmbed: false,
}
export const OttPlayerContext = createContext(defaultState)
type Props = {
  children: React.ReactNode
  isEmbed?: boolean
}
export const OttPlayerProvider = ({ children, isEmbed = false }: Props) => {
  const [videoPlaying, setVideoPlaying] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const onRouteChangeStart = () => {
      setVideoPlaying(false)
    }

    router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [router.events])

  return (
    <OttPlayerContext.Provider
      value={{ videoPlaying, setVideoPlaying, isEmbed }}
    >
      {children}
    </OttPlayerContext.Provider>
  )
}
export const useOttPlayer = () => {
  return useContext(OttPlayerContext)
}
